{
  "button-bar-for-continue-booking": {
    "button": {
      "cancel": "Abbrechen",
      "continue": "Fortfahren"
    },
    "text": {
      "continue-booking": "Ihre Buchung ist noch nicht abgeschlossen. Möchten Sie fortfahren?"
    }
  }
}
